import React from 'react';
import { SegmentedControl, Label } from '@spark';

const items = [
    { id: 'cpu', label: 'CPU' },
    { id: 'gpu', label: 'GPU' },
];

const HardwareDeviceSelector = (props) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, width: 122 }}>
            <Label label="Training Device" showAsterisk={false} showIcon={false} />
            <SegmentedControl
                items={items}
                activeId={props.trainingDevice}
                onChange={(id) => props.onHardwareDeviceChange(id)}
                size="small"
            />
        </div>
    );
};

export default HardwareDeviceSelector;
